module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Vimeo",
    style: (_vm.vimeoStyle),
    on: {
      "click": _vm.play,
      "mouseenter": function($event) {
        _vm.hover = true
      },
      "mouseleave": function($event) {
        _vm.hover = false
      }
    }
  }, [_c('div', {
    staticClass: "Vimeo-container"
  }, [_c('transition', {
    attrs: {
      "name": "Vimeo-preview-"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPreview && _vm.image),
      expression: "showPreview && image"
    }],
    staticClass: "Vimeo-preview"
  }, [_c('tag', {
    staticClass: "Vimeo-button",
    attrs: {
      "icon": "play",
      "label": _vm.buttonLabel,
      "meta": _vm.duration,
      "highlighted": _vm.hover,
      "large": ""
    }
  }), _vm._v(" "), (_vm.image) ? _c('image-component', _vm._b({
    staticClass: "Vimeo-image"
  }, 'image-component', _vm.image, false)) : _vm._e()], 1)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "Vimeo-video-"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showPreview),
      expression: "!showPreview"
    }],
    staticClass: "Vimeo-video",
    attrs: {
      "id": _vm.videoId
    },
    domProps: {
      "innerHTML": _vm._s(_vm.data.html)
    }
  })])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d9777bd6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Vimeo.vue
// module id = 799
// module chunks = 1474